exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reports h2[data-v-67a313ce]{text-align:center;margin:50px 0}.reports h2 span[data-v-67a313ce]{display:block}.reports h2 .lighter[data-v-67a313ce]{margin-top:15px;font-size:16px}.reports-listing[data-v-67a313ce]{padding-bottom:80px}.reports-listing .md-table+.md-table[data-v-67a313ce]{margin-top:50px}.filter-wrapper[data-v-67a313ce]{display:flex;position:relative;max-width:900px}.filter-wrapper .md-field[data-v-67a313ce]{margin-right:20px}.error[data-v-67a313ce]{font-size:22px;margin:50px 0;text-align:center;color:rgba(0,0,0,.87);font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67a313ce","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Tickets/ReportsAboutPlay.vue
// module id = 316
// module chunks = 0